module.exports = __webpack_public_path__ + "img/logo.e91aa239.png";